module.exports = __webpack_public_path__ + "img/info-icon.499cd944.svg";